import { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { User } from '../../classess/user/user';
import { Role } from '../../classess/role/role';

import {
    handleResponseMessageAsync, getProcessButtons, isUndNullEmp, isValidEmail, isValidPhoneNumber, getLanguageObj, getResponse, settings,
    styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { RoleUser } from '../../classess/role/roleUser';
import { UserService } from '../../services/users/UserService';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'UserAddEdit';

export default function UserAddEdit({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        typeModal: 0,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtUsersId: '',
        dtUsersRowId: 0,
        roles: [Role?.class({}, false)],
    },
    setModalObj = {},
    user = { ...User?.getClass({}, false), passwordConfirm: '', roleId: '', },
    setUser = {},
}) {
    //#region variables
    const [errors, setErrors] = useState({
        firstName: '', lastName: '', email: '', phoneNumber: '', department: '', position: '', password: '', passwordConfirm: '', role: '',
    });

    const [showPassword, setShowPassword] = useState(false);

    const [userLength] = useState(User?.minMaxLength(false));
    const isMount = useRef(true);
    const [process, setProcess] = useState({
        save: false,
    });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
            closeModal: {
                defaultClass: 'close text-secondary',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            department: {
                id: 'inputDepartment',
            },
            email: {
                id: 'inputEmail',
            },
            firstName: {
                id: 'inputFirstName',
            },
            lastName: {
                id: 'inputLastName',
            },
            password: {
                id: 'inputPassword',
            },
            passwordConfirm: {
                id: 'inputPasswordConfirm',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
            },
            position: {
                id: 'inputPosition',
            },
        },
        selects: {
            role: {
                id: 'selRole'
            },
        },
        spiners: {
            save: {
                id: 'spSave',
                defaultClass: '',
            }
        },
    };

    const [roleUserBefore] = useState({ ...RoleUser?.class({}, false), userId: user.id, roleId: user.roleId, });
    //#endregion variables

    //#region methods
    const addUser = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addUser';
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setShowPassword(false);
            setProcess(prev => ({ ...prev, save: true }));

            response = await UserService.addAsync({
                auth: modalObj?.auth,
                data: user,
                roleUser: {
                    roleId: user.roleId,
                    userId: user.id,
                },
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const newUser = User?.getClass(response?.result?.user || {}, false);
            modalObj.$(`#${modalObj.dtUsersId}`).DataTable().row.add([
                newUser.email,
                newUser.firstName,
                newUser.lastName,
                getProcessButtons({
                    id: newUser.id,
                    description: newUser.email,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                    processButtons: [],
                })?.result,
            ])?.draw(true);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    //#region analyst
    const editUser = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editUser';
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            response = await UserService.update({
                auth: modalObj?.auth,
                id: user.id,
                data: user,
                roleUserBefore: roleUserBefore,
                roleUserAfter: { ...roleUserBefore, roleId: user.roleId },
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const userData = User?.getClass(response?.result?.user || {}, false);
            setUser(userData);

            if (isUndNullEmp({ data: user?.roleId, subMethod: currentMethod })?.result) {
                modalObj?.$(`#${modalObj?.dtUsersId}`).DataTable().row(modalObj?.dtUsersRowId).remove()?.draw(true);
            } else {
                modalObj?.$(`#${modalObj?.dtUsersId}`).DataTable().row(modalObj?.dtUsersRowId).data([
                    userData.email,
                    userData.firstName,
                    userData.lastName,
                    getProcessButtons({
                        id: userData.id,
                        description: userData.email,
                        showDetails: false,
                        labelDetails: labels?.details[modalObj?.languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[modalObj?.languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                        enabledEdit: true,
                        processButtons: [],
                    })?.result,
                ])?.draw(true);
            }

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }
    //#endregion analyst

    //#region others
    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            const thisFieldRequired = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;
            if (isUndNullEmp({ data: user, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    firstName: thisFieldRequired,
                    lastName: thisFieldRequired,
                    email: thisFieldRequired,
                    phoneNumber: thisFieldRequired,
                    department: thisFieldRequired,
                    position: thisFieldRequired,
                    password: thisFieldRequired,
                    passwordConfirm: thisFieldRequired
                }));
                if (modalObj?.typeModal === 1 && modalObj?.type === 0) {
                    setErrors(prev => ({ ...prev, role: thisFieldRequired }));
                }
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.firstName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, firstName: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.lastName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, lastName: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.email, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, email: thisFieldRequired }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: user?.email, subMethod: currentMethod })?.result && !isValidEmail({ data: user?.email })) {
                setErrors(prev => ({ ...prev, email: `${messages?.youMustEnterValidEmail[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, phoneNumber: thisFieldRequired }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod })?.result && !isValidPhoneNumber({ data: user?.phoneNumber })) {
                setErrors(prev => ({ ...prev, phoneNumber: `${messages?.youMustEnterValidPhoneNumber[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.department, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, department: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.position, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, position: thisFieldRequired }));
                response.isWarning = true;
            }

            if (modalObj?.type === 0) {
                if (isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result) {
                    setErrors(prev => ({ ...prev, password: thisFieldRequired }));
                    response.isWarning = true;
                } else if (!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result &&
                    user?.password?.length < settings.passwords.minLength) {
                    setErrors(prev => ({ ...prev, password: `${messages?.youMustEnterValidPassword[modalObj?.languageObj?.id]}.` }));
                    response.isWarning = true;
                }
            } else if (modalObj?.typeModal === 1 && modalObj?.type === 1) {
                if (!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result &&
                    user?.password?.length < settings.passwords.minLength) {
                    setErrors(prev => ({ ...prev, password: `${messages?.youMustEnterValidPassword[modalObj?.languageObj?.id]}.` }));
                    response.isWarning = true;
                }
            }

            if (modalObj?.type === 0) {
                if (isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result) {
                    setErrors(prev => ({ ...prev, passwordConfirm: thisFieldRequired }));
                    response.isWarning = true;
                } else if (!isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result &&
                    user?.passwordConfirm?.length < settings.passwords.minLength) {
                    setErrors(prev => ({ ...prev, passwordConfirm: `${messages?.youMustEnterValidPasswordConfirm[modalObj?.languageObj?.id]}.` }));
                    response.isWarning = true;
                }
            } else if (modalObj?.typeModal === 1 && modalObj?.type === 1) {
                if (!isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result &&
                    user?.passwordConfirm?.length < settings.passwords.minLength) {
                    setErrors(prev => ({ ...prev, passwordConfirm: `${messages?.youMustEnterValidPasswordConfirm[modalObj?.languageObj?.id]}.` }));
                    response.isWarning = true;
                }
            }

            if (modalObj?.type === 0) {
                if (!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result &&
                    !isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result &&
                    user?.password !== user?.passwordConfirm) {
                    setErrors(prev => ({
                        ...prev,
                        password: `${messages?.passwordAndPasswordConfirmNotMatch[modalObj?.languageObj?.id]}.`,
                        passwordConfirm: `${messages?.passwordAndPasswordConfirmNotMatch[modalObj?.languageObj?.id]}.`
                    }));
                    response.isWarning = true;
                }
            } else if (modalObj?.typeModal === 1 && modalObj?.type === 1) {
                if ((!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result || !isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result) &&
                    user?.password !== user?.passwordConfirm) {
                    setErrors(prev => ({
                        ...prev,
                        password: `${messages?.passwordAndPasswordConfirmNotMatch[modalObj?.languageObj?.id]}.`,
                        passwordConfirm: `${messages?.passwordAndPasswordConfirmNotMatch[modalObj?.languageObj?.id]}.`
                    }));
                    response.isWarning = true;
                }
            }

            if (modalObj?.typeModal === 1 && modalObj?.type === 0) {
                if (isUndNullEmp({ data: user?.roleId, subMethod: currentMethod })?.result) {
                    setErrors(prev => ({
                        ...prev,
                        role: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`
                    }));
                    response.isWarning = true;
                }
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({
                ...prev,
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                department: '',
                position: '',
                password: '',
                passwordConfirm: '',
                role: ''
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        };
    }, []);
    //#endregion others
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered size="">
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='backupReviews'
                            src={modalObj?.typeModal === 0 ? images?.icons?.user : images?.icons?.analyst}
                            style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{modalObj?.typeModal === 0 ? labels?.user?.[modalObj?.languageObj?.id] : labels?.analyst?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <form onSubmit={(e) => modalObj?.type === 0 ?
                addUser({ e: e, subMethod: currentMethod, }) :
                modalObj?.typeModal === 1 && modalObj?.type === 1 ?
                    editUser({ e: e, subMethod: currentMethod }) :
                    e.preventDefault()}>
                <Modal.Body className='pt-0 px-4 bg-white'>
                    <div className='mt-3'>
                        {modalObj?.type !== 2 ? (
                            <div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.firstName?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input autoFocus
                                                id={controls?.inputs?.firstName?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength.max.firstName}
                                                onChange={(e) => setUser({ ...user, firstName: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, firstName: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.firstName?.id, })?.result && !isUndNullEmp({ data: user?.firstName, subMethod: controls?.inputs?.firstName?.id, })?.result ?
                                                    user.firstName : ''}
                                                placeholder={labels?.firstName?.[modalObj?.languageObj?.id]}
                                                title={labels?.firstName?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.firstName)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.lastName?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.lastName?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength?.max?.lastName}
                                                onChange={(e) => setUser({ ...user, lastName: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, lastName: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.lastName?.id, })?.result && !isUndNullEmp({ data: user?.lastName, subMethod: controls?.inputs?.lastName?.id, })?.result ?
                                                    user.lastName : ''}
                                                placeholder={labels?.lastName?.[modalObj?.languageObj?.id]}
                                                title={labels?.lastName?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.lastName)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.envelope} mr-1`} /> {labels?.email?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.email?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength?.max?.email}
                                                onChange={(e) => setUser({ ...user, email: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.email?.id, })?.result && !isUndNullEmp({ data: user?.email, subMethod: controls?.inputs?.email?.id, })?.result ?
                                                    user.email : ''}
                                                placeholder={labels?.email?.[modalObj?.languageObj?.id]}
                                                title={labels?.email?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.email)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.mobileAlt} mr-1`} /> {labels?.phoneNumber?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.phoneNumber?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength?.max?.phoneNumber}
                                                onChange={(e) => setUser({ ...user, phoneNumber: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, phoneNumber: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.phoneNumber?.id, })?.result && !isUndNullEmp({ data: user?.phoneNumber, subMethod: controls?.inputs?.phoneNumber?.id, })?.result ?
                                                    user.phoneNumber : ''}
                                                placeholder={labels?.phoneNumber?.[modalObj?.languageObj?.id]}
                                                title={labels?.phoneNumber?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.phoneNumber)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.department?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.department?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength?.max?.department}
                                                onChange={(e) => setUser({ ...user, department: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.department?.id, })?.result && !isUndNullEmp({ data: user?.department, subMethod: controls?.inputs?.department?.id, })?.result ?
                                                    user.department : ''}
                                                placeholder={labels?.department?.[modalObj?.languageObj?.id]}
                                                title={labels?.department?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.department)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.idBadge} mr-1`} /> {labels?.position?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.position?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength?.max?.position}
                                                onChange={(e) => setUser({ ...user, position: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, position: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.position?.id, })?.result && !isUndNullEmp({ data: user?.position, subMethod: controls?.inputs?.position?.id, })?.result ?
                                                    user.position : ''}
                                                placeholder={labels?.position?.[modalObj?.languageObj?.id]}
                                                title={labels?.position?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.position)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                                <small className='text-muted text-uppercase font-weight-bold'>
                                                    <i className={`${icons?.fasFa?.lock} mr-1`} /> {labels?.password?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <span style={{ cursor: 'pointer', fontSize: '1.2rem' }} className='text-primary' onClick={() => setShowPassword(!showPassword)}>
                                                    <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                </span>
                                            </div>
                                            <input id={controls?.inputs?.password?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength.max.password}
                                                onChange={(e) => setUser({ ...user, password: e?.target?.value, })}
                                                onFocus={() => setErrors(prev => ({ ...prev, password: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.password?.id, })?.result && !isUndNullEmp({ data: user?.password, subMethod: controls?.inputs?.password?.id, })?.result ?
                                                    user.password : ''}
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder={labels?.password?.[modalObj?.languageObj?.id]}
                                                title={labels?.password?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.password)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                                <small className='text-muted text-uppercase font-weight-bold'>
                                                    <i className={`${icons?.fasFa?.lock} mr-1`} /> {labels?.passwordConfirm?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <span style={{ cursor: 'pointer', fontSize: '1.2rem' }} className='text-primary' onClick={() => setShowPassword(!showPassword)}>
                                                    <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                </span>
                                            </div>
                                            <input id={controls?.inputs?.passwordConfirm?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                readOnly={process?.save}
                                                maxLength={userLength.max.password}
                                                onChange={(e) => setUser({ ...user, passwordConfirm: e?.target?.value, })}
                                                onFocus={() => setErrors(prev => ({ ...prev, passwordConfirm: '' }))}
                                                value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.passwordConfirm?.id, })?.result && !isUndNullEmp({ data: user?.passwordConfirm, subMethod: controls?.inputs?.passwordConfirm?.id, })?.result ?
                                                    user.passwordConfirm : ''}
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder={labels?.passwordConfirm?.[modalObj?.languageObj?.id]}
                                                title={labels?.passwordConfirm?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.passwordConfirm)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.idCard} mr-1`} /> {labels?.role[modalObj?.languageObj?.id]}
                                            </small>
                                            <select id={controls?.selects?.role?.id}
                                                className='custom-select bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                disabled={process?.save}
                                                value={user?.roleId || ''}
                                                onChange={(e) => setUser({ ...user, roleId: e?.target?.value, })}
                                                onFocus={() => setErrors(prev => ({ ...prev, role: '' }))}
                                                placeholder={labels?.role[modalObj?.languageObj?.id]}
                                                title={labels?.role[modalObj?.languageObj?.id]}>
                                                <option key={`nothing`} value={``}>{messages?.selectRole?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj.roles.map((role) => <option key={role.id} value={role.id}>{role.name}</option>)}
                                            </select>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.role)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='text-muted'></div>
                        )}

                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass}`} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`} /> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}